import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';

const ContactSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  const contactMethods = [
    {
      icon: 'ri-mail-line',
      label: 'EMAIL',
      value: 'contact@truepassage.com',
      link: 'mailto:contact@truepassage.com',
    },
    {
      icon: 'ri-whatsapp-line',
      label: 'WHATSAPP',
      value: '+1 (437) 981-2110',
      link: 'https://wa.me/14379812110',
    },
    {
      icon: 'ri-phone-line',
      label: 'PHONE',
      value: '+91 9952529203',
      link: 'tel:+919952529203',
    },
  ];

  return (
    <section id="contact" ref={ref} className="py-16 sm:py-20 lg:py-24 bg-[#0a1628] relative overflow-hidden">
      {/* Animated Background Elements */}
      <motion.div
        className="absolute top-0 right-0 w-96 h-96 bg-gold-accent/5 rounded-full blur-3xl"
        animate={isInView ? { scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] } : {}}
        transition={{ duration: 8, repeat: Infinity }}
      />

      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <motion.div
            className="lg:col-span-3 text-center lg:text-left"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-5 leading-tight">
              Start Your Global
              <br />
              <span className="text-gold-accent">Sourcing Journey</span>
            </h2>
            <p className="text-sm sm:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0">
              Tell us what you need. Our team will respond within 24 hours.
            </p>
          </motion.div>

          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="bg-white/8 backdrop-blur-sm rounded-2xl p-6 sm:p-8 lg:p-10 border border-white/15">
              <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
                {contactMethods.map((method, index) => (
                  <motion.a
                    key={method.label}
                    href={method.link}
                    className="flex items-center gap-3 sm:gap-4 group cursor-pointer"
                    initial={{ opacity: 0, x: 20 }}
                    animate={isInView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                  >
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gold-accent/20 rounded-xl flex items-center justify-center group-hover:bg-gold-accent transition-colors flex-shrink-0">
                      <i className={`${method.icon} text-gold-accent group-hover:text-navy-primary text-lg sm:text-xl transition-colors`}></i>
                    </div>
                    <div className="min-w-0">
                      <div className="text-xs uppercase tracking-wider text-white/50 mb-1">
                        {method.label}
                      </div>
                      <div className="text-sm sm:text-base font-medium text-white group-hover:text-gold-accent transition-colors truncate">
                        {method.value}
                      </div>
                    </div>
                  </motion.a>
                ))}
              </div>

              <Link
                to="/request-quote"
                className="block w-full py-3 sm:py-4 px-6 sm:px-8 bg-gold-accent text-navy-primary rounded-full font-semibold text-sm sm:text-base text-center hover:scale-[1.02] transition-transform shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
